import * as Yup from "yup";

export enum RouteSupportedFormats {
  gpx = "gpx",
  zip = "zip",
}

export const CreateOrUpdateOsaWaySchema = Yup.object().shape({
  name: Yup.string()
    .min(2, "Must be 2 characters or more")
    .max(256, "Must be 256 characters or less")
    .required("Route name must be filled in"),
});

export const CreateNodesSchema = Yup.object().shape({
  fileFormat: Yup.string().required(),
  zipOutputsFile: Yup.mixed().when("fileFormat", {
    is: (value: string) => RouteSupportedFormats.zip === value,
    then: Yup.mixed().required(),
  }),
  zipPicturesFile: Yup.mixed().when("fileFormat", {
    is: (value: string) => RouteSupportedFormats.zip === value,
    then: Yup.mixed().required(),
  }),
  gpxFile: Yup.mixed().when("fileFormat", {
    is: (value: string) => RouteSupportedFormats.gpx === value,
    then: Yup.mixed().required(),
  }),
  gpxPicturesFile: Yup.mixed().when("fileFormat", {
    is: (value: string) => RouteSupportedFormats.gpx === value,
    then: Yup.mixed().required(),
  }),
});

export interface OsaWayFormData {
  projectId?: string;
  name: string;
}

export interface NodeFormData {
  fileFormat?: RouteSupportedFormats;
  zipOutputsFile?: File;
  zipPicturesFile?: File;
  gpxFile?: File;
  gpxPicturesFile?: File;
}
